export const normalizeProductInfo = (rawData) => {
  if (!rawData) return
  return {
    productId: rawData.product_id,
    productCode: rawData.product_code,
    masterTitle: rawData.master_title,
    masterTitleDescription: rawData.master_title_description,
    title: rawData.title,
    titleDescription: rawData.title_description,
    purchaseAmount: rawData.purchase_amount,
    durationStart: rawData.duration_start,
    durationEnd: rawData.duration_end,
    downloadContentCount: rawData.download_content_count,
    packageTypeId: rawData.package_type_id,
    screenTypeId: rawData.screen_type_id,
    screenQualityId: rawData.screen_quality_id,
    isAuto: rawData.is_auto,
    concurrentWatchCount: rawData.concurrent_watch_count,
    partnerId: rawData.partner_id,
    packageMasterId: rawData.package_master_id,
    marketTypeId: rawData.market_type_id,
    chargeTypeId: rawData.charge_type_id,
  }
}
